import { TextColor } from '@kite-js/theme-types';

const lightScale: TextColor = {
    100: '#f9f9fa',
    300: '#b1b1b3',
    500: '#737373',
    800: '#2a2a2e',
};

export default lightScale;
